
export const defaultFormData = {
  userName: {
    value: '',
    required: true,
  },
  password: {
    value: '',
    required: true,
  },
  databaseName: {
    value: '',
    required: true,
  },
  sourcePath: {
    value: '',
    required: true,
  },
  sourceIp: {
    value: '',
    required: true,
  },
  sourceDomain: {
    value: '',
    required: true,
  },
  destinationPath: {
    value: '',
    required: false,
  },
  sourcePort: {
    value: '',
    required: false,
  },
};
